import React, {useEffect} from "react";
import {Input} from "reactstrap";
import {formatDate, getCurYears} from "../../script/commFunc";

/**
 *
 * @User : 백욱진
 * @Date : 2023.05.04
 * @file : Components/Common/CpmCommYear.js
 * @Desc : 데이트 픽커 컴포넌트(yyyy)
 * @param {string} id - id값 (부모 컴포넌트의 파라미터 key 값으로도 사용)
 * @param {Array<object>} selectOptions - 데이터 [{label: string, value: any}]
 * @param {object} params - 부모 컴포넌트로부터 받아온 파라미터 객체
 * @param {React.SetStateAction} setParams - 부모 컴포넌트로부터 받아온 파라미터 세터
 * @param {string} label - 라벨
 * @param {boolean} essential - 필수 여부
 */

const CpmCommYear = ({
    id, 
    selectOptions, 
    params, 
    setParams,
    label,
    essential = false,
}) => {
    const paramNm = id || 'year'
    const currYear = new Date().getFullYear() // 올해
    const options =
        selectOptions ||
        getCurYears().map((el) => {
            return {value: el, label: `${el}년`};
        });

    const onChangeHandle = (e) => {
        setParams({[paramNm]: e.target.value});
    };

    useEffect(() => {
        // 초기값 부모 params에 세팅 (올해)
        setParams({[paramNm]: currYear});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Input
                id={id}
                name={label || paramNm}
                type="select"
                bsSize="sm"
                className={`${essential && 'essential'} form-control`}
                onChange={onChangeHandle}
                defaultValue={formatDate(params[paramNm], 'yyyy')}
            >
                {options.map((el, idx) => {
                    return (
                        <option key={`Options_${idx}`} value={el.value}>
                            {el.label}
                        </option>
                    );
                })}
            </Input>
        </>
    );
};

export default CpmCommYear;
